import { FC, useCallback, useState } from 'react'
import Helmet from 'react-helmet'
import Page from 'rui/widgets/Page'
import { Container, Spacer, Text } from 'roadie-ui'
import { ExternalLink } from 'components/layout/links'
import { AnchorButton } from 'components/layout/buttons'
import { Form } from 'roadie-ui'
import { sendNativeMessage } from 'util/native'
import { LocalizedRichText, useLocalization, LocalizedText } from 'localization'

const DeleteAccountPage: FC = () => {
  const { t } = useLocalization()
  const [agreed, setAgreed] = useState(false)
  const handleCheck = useCallback((checked: boolean) => {
    setAgreed(checked)
  }, [])
  const handleSubmit = useCallback(() => {
    if (!agreed) {
      return
    }

    window.setTimeout(() => {
      sendNativeMessage({ type: 'CLOSE_WEBVIEW' })
    }, 0)
  }, [agreed])
  const email = agreed
    ? {
        to: 'privacy@roadie.com',
        subject: t('dweb_account_delete_account_email_subject'),
        body: t('dweb_account_delete_account_email_body'),
      }
    : null
  return (
    <Page>
      <Helmet>
        <title>{t('dweb_edit_account_nav_delete_account')}</title>
      </Helmet>
      <Container.Panel>
        <Text.H4 $color="neutral-black" $textAlign="center">
          <LocalizedText translationKey="dweb_edit_account_nav_delete_account" />
        </Text.H4>
        <Spacer $height=".8rem" />
        <Text.Subtitle1 $color="neutral-black" $textAlign="center">
          <LocalizedText translationKey="dweb_delete_account_request_scope" />
        </Text.Subtitle1>
        <Spacer $height="1.6rem" />
        <Text.Body2 $color="neutral-black">
          <LocalizedText translationKey="dweb_delete_account_confirmation_intro" />
        </Text.Body2>
        <Spacer $height="1.6rem" />
        <Text.Body2>
          <LocalizedRichText
            translationKey="dweb_delete_account_retention_notice"
            params={{
              link1: (
                <ExternalLink href="https://www.roadie.com/privacy">
                  <LocalizedText translationKey="dweb_account_delete_account_www_roadie_com_privacy" />
                </ExternalLink>
              ),
            }}
          />
        </Text.Body2>
        <Spacer $height="2.8rem" />
        <Form.Checkbox
          onChange={handleCheck}
          checked={agreed}
          name="agree"
          label={t('dweb_account_delete_account_i_confirm_i_would_like_delete_my_account')}
        />
        <Spacer $height="2.8rem" />
        <Container.Base onClick={handleSubmit}>
          <AnchorButton disabled={!agreed} mode="primary" email={email}>
            <LocalizedText translationKey="dweb_account_delete_account_submit_request" />
          </AnchorButton>
        </Container.Base>
      </Container.Panel>
    </Page>
  )
}

export default DeleteAccountPage
